<template>
  <div id="search-autocomplete-container">
    <SearchBox />
  </div>
</template>

<script>
import SearchBox from './components/SearchBox.vue';
import './global.css';

export default {
  name: 'App',
  components: {
    SearchBox
  }
}
</script>

<style scoped>
*, *:before, *:after {
  box-sizing: border-box;
}
</style>

<style>
#search-autocomplete-container {
  font-family: var(--font-family-base);
  max-width: 620px;
}

@media only screen and (max-width: 767px) {
  .catalog-product-view:not(.search-active) #search-autocomplete {
    display: none;
  }

  /* Double root selector is a specificity hack to be greater than the :not above */
  .mmactive.mmactive #search-autocomplete,
  .autocomplete-open.autocomplete-open #search-autocomplete {
    display: block;
  }
}
</style>
